<template>
  <div class="footer-container flex justify-between items-center p-4">
    <!-- Language Selection -->
    <div class="language-select">
			<client-only>
      <Select
        v-model="selectedLanguage"
        :options="availableLocales"
        optionLabel="name"
        optionValue="code"
        class="language-dropdown bg-transparent !border-none !shadow-none"
        placeholder="Select Language"
        @change="setLocale(selectedLanguage)"
        overlayClass="footer-languages"
        v-if="!hideLanguageSelection"
      >
      <!-- Selected value template -->
      <template #value="slotProps">
        <div v-if="slotProps.value" class="flex items-center">
          <img
            :src="`/images/flags/${slotProps.value}.svg`"
            :alt="getLocaleName(slotProps.value)"
            class="mr-1 md:mr-2 w-[18px] h-[12px] md:w-[18px] md:h-[12px]"
          />
          <div class="app-list-option app-list-option-footer">{{ getLocaleName(slotProps.value) }}</div>
        </div>
        <span v-else>
            {{ slotProps.placeholder }}
          </span>
      </template>

      <!-- Option template in dropdown -->
      <template #option="slotProps" class="footer-prop">
        <div class="flex items-center">
          <img
            :src="`/images/flags/${slotProps.option.code}.svg`"
            :alt="getLocaleName(slotProps.option.code)"
            class="mr-1 md:mr-2 w-[18px] h-[12px] md:w-[18px] md:h-[12px]"
          />
          <div class="app-list-option app-list-option-footer">{{ getLocaleName(slotProps.option.code) }}</div>
        </div>
      </template>
      </Select>
			</client-only>
    </div>

    <!-- Copyright -->
    <div class="copyright text-sm leading-6 mb-6 md:mb-0">
      © {{ currentYear }} Media4Change
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed, onMounted} from 'vue';
import { useLocalesStore } from "@/stores/i18n"

const route = useRoute();
const localesStore = useLocalesStore()
const { setLocale, t } = localesStore

const props = defineProps({
  hideLanguageSelection: {
    type: Boolean,
    default: false
  },
});

/*const { t } = useI18n();*/

/*const { locale, locales, setLocale } = useI18n();*/
const currentYear = new Date().getFullYear();

// Reference selected language directly from the store
const selectedLanguage = computed({
	get: () => localesStore.locale,
	set: (value) => setLocale(value),
});

const supported = ['lt', 'en']

// Use the store's availableLocales directly
const availableLocales = computed(() =>
	localesStore.availableLocales
		.filter(code => supported.includes(code))
		.map(code => ({
			code,
			name: t(`languages.${code}`),       // Translate the locale name
			flag: `/images/flags/${code}.svg`,  // Generate the flag URL
		}))
)


// Get the locale name for displaying selected value
/*
const getLocaleName = (code: string) => {
  const locale = availableLocales.value.find(locale => locale.code === code);
  return locale ? locale.name : '';
}
*/

const getLocale  = route.query?.locale ?? '';

// Get the locale name from translations
// Get the locale name for displaying selected value
const getLocaleName = (code: string) => {
	if (code) {
		return t(`languages.${code}`);
	}
	return '';
};

onMounted(() => {
	const routeLocale = useRoute().query.locale;

	if (typeof routeLocale === 'string' && localesStore.availableLocales.includes(routeLocale)) {
		setLocale(routeLocale as I18nLangCode);
	}
});


</script>

<style scoped lang="scss">
.footer-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 768px) {
    position: relative;
    bottom: auto;
    left: auto;
    right: auto;
    padding-bottom: 110px;
  }
}

.language-dropdown {
  border: none;
  background-color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  @media (max-width: 768px) {
    font-size: 14px;
  }
}

.language-select {
  position: absolute;
  left: 25px;
  bottom: 20px;
  .p-select {
    //padding-right: 0;
    width: auto !important;
    padding: 0 !important;
    .p-select-label {
      padding: 0;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    top: 25px;
    right: 0;
    left: 0;
    bottom: 0;
    text-align: center;
  }
}

.copyright {
  position: absolute;
  right: 25px;
  bottom: 24px;

  @media (max-width: 768px) {
    width: 100%;
    top: 61px;
    right: 0;
    left: 0;
    bottom: 20px;
    text-align: center;
    font-size: 14px !important;
  }
}
</style>
